<template>
  <div class="animated revealUp">
    <div class="white-wrapper cinema-overiew-template">
      <div class="section-title">{{ $t("cinemaOverviewReport") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="selectedDate"
                  @click.prevent="onClearDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-validate="'required'"
                  :value="selectedDate"
                  :disabledDates="disabledDates"
                  typeable
                  @selected="onDateHandler($event)"
                ></Datepicker>
                <label :class="selectedDate ? 'active' : ''">{{
                  $t("date")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.cine_id ? 'shift-up' : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema.cine_name"
                class="w-100"
                variant="dropdown-curve"
              >
                <div class="px-2 pb-2">
                  <input
                    v-model="searchCinema"
                    autofocus
                    class="form-control form-control-sm"
                    :placeholder="$tc('searchCinema')"
                    required
                    type="search"
                    v-on:keydown="onSearchCinema()"
                    v-on:keyup="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    cineDropDownHandler({
                      event: $event,
                      name: 'Cinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    getCinemaOverviewReport();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedScreen &&
                  (selectedScreen.screen_id ||
                    selectedScreen.screen_name === 'All')
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("screen", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedScreen.screen_name"
                class="w-100"
                variant="dropdown-curve"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in CineScreens"
                  :key="dropdownIndex"
                  @click="
                    cineScreenDropDownHandler({
                      event: $event,
                      name: 'Screen',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    })
                  "
                  >{{ dropdownItem.screen_name }}
                </b-dropdown-item>
                <b-dropdown-item
                  key="allscreens"
                  @click="
                    cineScreenDropDownHandler({
                      event: $event,
                      name: 'Screen',
                      selectedItem: { screen_id: null, screen_name: 'All' },
                      index: 0,
                    })
                  "
                >
                  All
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3" v-if="false">
            <button class="btn-blue-lg w-100" @click="onFetchReport()">
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-4 align-self-center mb-3 d-flex justify-content-end"
          >
            <b-dropdown name="listview" id="listview" variant="outline-blue">
              <template v-slot:button-content>
                {{ $t("viewing") }}&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp;
                <strong>{{ rows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>

            <div
              v-if="myCinemaSchedule.length > 0"
              class="d-flex justify-content-end mb-0 align-items-center ml-1"
            >
              <div class="mr-2">{{ $t("Download as:") }}:</div>
              <a
                v-if="true"
                :href="
                  BASE_URL +
                  `/api/admin/export_show_overview${queryString}${
                    queryString ? '&isPdf=Y' : '?isPdf=Y'
                  }`
                "
                target="_blank"
                title="Download as PDF"
                download
              >
                <img
                  src="@/assets/img/icons/pdf-icon.svg"
                  height="25"
                  width="25"
                />
              </a>
              <a
                :href="
                  BASE_URL + `/api/admin/export_show_overview${queryString}`
                "
                target="_blank"
                title="Download as Excel"
                download
              >
                <img
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-end align-items-center my-3"
        v-if="false"
      >
        <div class="d-flex align-items-center">
          <div class="">
            <b-dropdown name="listview" id="listview" variant="outline-blue">
              <template v-slot:button-content>
                {{ $t("viewing") }}&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp;
                <strong>{{ rows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>

      <div class="" v-if="false">
        <div class="data-body headFont">
          <div class="data-row border-bottom">
            <div class="row p-2 headerRow">
              <div class="col-1">
                <div class="d-flex w-100 justify-content-center mt-3">
                  <!-- <div class="pr-3">{{ $t("collapse") }}</div> -->
                </div>
              </div>
              <div class="col-11">
                <div class="d-flex align-items-center lh-25 mt-3">
                  <span class="w-100">
                    {{ $t("date") }}
                  </span>
                  <span class="w-100">
                    {{ $t("time") }}
                  </span>
                  <span class="w-100">
                    {{ $t("timeleft") }}
                  </span>
                  <span class="w-100">
                    {{ $tc("movie", 1) }}
                  </span>
                  <span class="w-100">
                    {{ $t("showType") }}
                  </span>
                  <span class="w-100">
                    {{ $tc("screen", 1) }}
                  </span>
                  <span class="w-100">
                    {{ $t("remarks") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data-body" v-if="myCinemaSchedule.length > 0">
          <div
            class="data-row border-bottom"
            v-for="(item, key) in myCinemaSchedule"
            :key="key"
          >
            <div class="row p-2">
              <div class="col-1" v-b-toggle="'moreDetails-' + key">
                <div class="d-flex w-100 justify-content-center mt-3">
                  <button
                    class="btn-transparent"
                    v-if="item.moreDetailsCollapse"
                  >
                    <span class="collaplsePlusMinusBtn">-</span>
                  </button>
                  <button class="btn-transparent" v-else>
                    <span class="collaplsePlusMinusBtn">+</span>
                  </button>
                </div>
              </div>
              <div class="col-11">
                <div
                  class="d-flex align-items-center lh-25"
                  :class="missingData(item) ? 'missingData' : ''"
                >
                  <span class="w-100">
                    {{ item.ss_start_date | dateparse }}
                  </span>
                  <span class="w-100">
                    {{ formatTimeCell(item.ss_start_show_time) }}-{{
                      formatTimeCell(item.ss_end_show_time)
                    }}
                  </span>
                  <span class="w-100">
                    {{
                      timeRemainingCounter(
                        combineDateAndTime(
                          item.ss_start_date,
                          item.ss_start_show_time
                        ),
                        item.tz_name
                      )
                    }}
                  </span>
                  <span class="w-100 movieNameCell">
                    {{ item.movie }}
                  </span>
                  <span class="w-100">
                    {{ item.show_type }}
                  </span>
                  <span class="w-100">
                    {{ item.screen_name }}
                  </span>
                  <span class="w-100">
                    {{ item.special_request || "-" }}
                  </span>
                </div>
              </div>
            </div>

            <b-collapse
              :id="'moreDetails-' + key"
              class="cinema-overview-collapse"
              v-model="item.moreDetailsCollapse"
            >
              <div class="row">
                <div class="col-md-3 mb-3">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label :class="item.selected_kdm ? 'shift-up' : ''">
                        {{ $t("KDM") }}
                      </label>
                      <multiselect
                        v-model="item.selected_kdm"
                        placeholder="KDM"
                        @select="onSelectKdm($event, key)"
                        :options="kdmArray"
                        label="kdm_title"
                        track-by="kdm_id"
                        :multiple="false"
                        name="kdm"
                        id="kdm"
                        select-label="Select"
                        deselect-label="Remove"
                        :class="!item.selected_kdm ? 'danger-border' : ''"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        v-model="item.key_valid_from"
                        type="text"
                        name="key_valid_from"
                        id="key_valid_from"
                        placeholder="."
                        :class="!item.key_valid_from ? 'danger-border' : ''"
                      />
                      <label>{{ $t("key_valid_from") }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        v-model="item.key_valid_to"
                        type="text"
                        name="key_valid_to"
                        id="key_valid_to"
                        placeholder="."
                        :class="!item.key_valid_to ? 'danger-border' : ''"
                      />
                      <label>{{ $t("key_valid_to") }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-2">
                  <div class="d-flex align-items-center">
                    <label class="mr-2">DCP Available</label>
                    <b-form-checkbox
                      name="check-button"
                      value="Y"
                      unchecked-value="N"
                      switch
                      v-model="item.dcp_available"
                    ></b-form-checkbox>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        v-model="item.tms_id"
                        type="text"
                        name="CPL"
                        id="CPL"
                        placeholder="."
                        :class="!item.tms_id ? 'danger-border' : ''"
                      />
                      <label>{{ $t("CPL") }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <button class="btn-blue" @click="udpateDcpInfo(item)">
                    {{ $t("update") }}
                  </button>
                </div>
              </div>
              <div v-if="item.cinema_booking_type_id == 3">
                <span class="font-weight-bold text-blue fs-16 ml-1"
                  >Customer Details:</span
                >
                <table class="list-view-table border my-2">
                  <thead>
                    <tr>
                      <th>{{ "Customer Name" }}</th>
                      <th>{{ "Email" }}</th>
                      <th>{{ "Contact" }}</th>
                      <th>{{ "is Guest User" }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{ item.customer_name || "-" }}
                      </td>
                      <td>{{ item.customer_email || "-" }}</td>
                      <td>
                        {{ item.customer_mobile ? item.customer_mobile : "-" }}
                      </td>
                      <td>{{ item.is_guest_user || "N" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-collapse>
          </div>
        </div>

        <div class="pb-3" v-else>
          <NoRecords classes="mb-0" />
        </div>

        <b-pagination
          class="mt-4"
          v-if="myCinemaSchedule.length > 0"
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
        ></b-pagination>

        <div
          v-if="myCinemaSchedule.length > 0"
          class="d-flex justify-content-end mb-2 mx-3 align-items-center"
        >
          <div class="mr-2">{{ $t("export") }}:</div>
          <a
            v-if="true"
            :href="
              BASE_URL +
              `/api/admin/export_show_overview${queryString}${
                queryString ? '&isPdf=Y' : '?isPdf=Y'
              }`
            "
            target="_blank"
            title="Download as PDF"
            download
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a
            :href="BASE_URL + `/api/admin/export_show_overview${queryString}`"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>

      <div class="swc-report overview-table">
        <table class="swc-report-table mb-3 text-left" border="1">
          <thead
            class="headerRowTable bg-lightgrey"
            style="color: black; text-align: center"
          >
            <tr>
              <th></th>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("time") }}</th>
              <th>{{ $t("timeleft") }}</th>
              <th>{{ $tc("movie", 1) }}</th>
              <th>{{ $t("showType") }}</th>
              <th>{{ $tc("screen", 1) }}</th>
              <th>{{ $t("remarks") }}</th>
            </tr>
          </thead>
          <tbody
            v-for="(item, key) in myCinemaSchedule"
            :key="key"
            class="sph-report light_grey_back"
          >
            <tr :class="missingData(item) ? 'missingData' : ''">
              <td>
                <div class="d-flex w-100 justify-content-center mt-3">
                  <button
                    class="btn-transparent"
                    v-if="item.moreDetailsCollapse"
                    @click="toggleRow(false, key)"
                  >
                    <span class="collaplsePlusMinusBtn">-</span>
                  </button>
                  <button
                    class="btn-transparent"
                    v-else
                    @click="toggleRow(true, key)"
                  >
                    <span class="collaplsePlusMinusBtn">+</span>
                  </button>
                </div>
              </td>
              <td class="text-right pr-2">
                {{ item.ss_start_date | dateparse }}
              </td>
              <td class="text-right pr-2">
                {{ formatTimeCell(item.ss_start_show_time) }}-{{
                  formatTimeCell(item.ss_end_show_time)
                }}
              </td>
              <td>
                {{
                  timeRemainingCounter(
                    combineDateAndTime(
                      item.ss_start_date,
                      item.ss_start_show_time
                    ),
                    item.tz_name
                  )
                }}
              </td>
              <td>{{ item.movie }}</td>
              <td>{{ item.show_type }}</td>
              <td>{{ item.screen_name }}</td>
              <td>{{ item.special_request || "-" }}</td>
            </tr>
            <tr v-if="item.moreDetailsCollapse">
              <td colspan="8">
                <b-collapse
                  :id="'moreDetails-' + key"
                  class="cinema-overview-collapse"
                  v-model="item.moreDetailsCollapse"
                >
                  <div class="row">
                    <div class="col-md-3 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <label :class="item.selected_kdm ? 'shift-up' : ''">
                            {{ $t("KDM") }}
                          </label>
                          <multiselect
                            v-model="item.selected_kdm"
                            placeholder="KDM"
                            @select="onSelectKdm($event, key)"
                            :options="kdmArray"
                            label="kdm_title"
                            track-by="kdm_id"
                            :multiple="false"
                            name="kdm"
                            id="kdm"
                            select-label="Select"
                            deselect-label="Remove"
                            :class="!item.selected_kdm ? 'danger-border' : ''"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="item.key_valid_from"
                            type="text"
                            name="key_valid_from"
                            id="key_valid_from"
                            placeholder="."
                            :class="!item.key_valid_from ? 'danger-border' : ''"
                          />
                          <label>{{ $t("key_valid_from") }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="item.key_valid_to"
                            type="text"
                            name="key_valid_to"
                            id="key_valid_to"
                            placeholder="."
                            :class="!item.key_valid_to ? 'danger-border' : ''"
                          />
                          <label>{{ $t("key_valid_to") }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 mt-2">
                      <div class="d-flex align-items-center">
                        <label class="mr-2">DCP Available</label>
                        <b-form-checkbox
                          name="check-button"
                          value="Y"
                          unchecked-value="N"
                          switch
                          v-model="item.dcp_available"
                        ></b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="item.tms_id"
                            type="text"
                            name="CPL"
                            id="CPL"
                            placeholder="."
                            :class="!item.tms_id ? 'danger-border' : ''"
                          />
                          <label>{{ $t("CPL") }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 mb-3">
                      <button class="btn-blue" @click="udpateDcpInfo(item)">
                        {{ $t("update") }}
                      </button>
                    </div>
                  </div>
                  <div v-if="item.cinema_booking_type_id == 3">
                    <span class="font-weight-bold text-blue fs-16 ml-1"
                      >Customer Details:</span
                    >
                    <table class="list-view-table border my-2">
                      <thead>
                        <tr>
                          <th>{{ "Customer Name" }}</th>
                          <th>{{ "Email" }}</th>
                          <th>{{ "Contact" }}</th>
                          <th>{{ "is Guest User" }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{ item.customer_name || "-" }}
                          </td>
                          <td>{{ item.customer_email || "-" }}</td>
                          <td>
                            {{
                              item.customer_mobile ? item.customer_mobile : "-"
                            }}
                          </td>
                          <td>{{ item.is_guest_user || "N" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-collapse>
              </td>
            </tr>
          </tbody>
          <tbody v-if="myCinemaSchedule.length == 0">
            <tr>
              <td colspan="13">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination
        class="mt-4"
        v-if="myCinemaSchedule.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportService from "@/services/ReportsService";
import vue from "vue";
import scheduleService from "@/services/scheduleService";
import PosService from "../../../services/PosService";
import { groupBy } from "lodash";
import moment from "moment";
import momentT from "moment-timezone";
import CinemasService from "../../../services/CinemasService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import StatusDot from "@/components/Partials/StatusDot.vue";
import VueTimepicker from "vue2-timepicker";
import { createQueryString } from "@/services/ApiHelper";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    NoRecords,
    StatusDot,
    VueTimepicker,
  },
  data() {
    return {
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      kdmArray: [
        {
          kdm_id: 1,
          kdm_title: "No KDM",
        },
        {
          kdm_id: 2,
          kdm_title: "KDM myCinema",
        },
        {
          kdm_id: 3,
          kdm_title: "KDM Studio",
        },
      ],
      BASEURL,
      PdfPath: "",
      myCinemaSchedule: [],
      DailyReportDataV2: [],
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      selectedCinema: { cine_id: null },
      searchCinema: "",
      options: {
        text: {
          shadowEnable: true,
          shadowColor: "#000000",
          color: "#D3D3D3",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: true,
        },
        progress: {
          color: "#9ACD32",
          backgroundColor: "#D3D3D3",
          inverted: false,
        },
        layout: {
          height: 20,
          width: 75,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
      scheduleShows: [],
      CineScreens: [],
      selectedScreen: { screen_id: null },
      selectedDate: moment().toDate(),
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: 10,

      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      interval: null,
      timer: null,

      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
    };
  },
  computed: {
    ...mapGetters([
      // GET LIST ONLY
      "getPosUsersList",
      "getPaymentTypesList",
      "getCinemasList",
      "getDailyConcessionReportList",
      // Flags
      "getDailyReportsIsCinema",
      "getDailyReportsIsExcelDownload",
      // Rendered List
      "getDailyReportList",
      "getDailyRefundList",
      // Selected Dates
      "getDailyReportToDate",
      "getDailyReportFromDate",
      // Selected Dropdowns
      "getDailyReportSelectedPaymentMode",
      "getDailyReportSelectedPosUser",
      "getDailyReportSelectedCinema",
      // FILEs
      "getDailyExcelFileName",
      // PSD
      "getDailyPDFFileName",
      // GET TOTALs
      "getGrandTotal",
      "getBoxOfficeTotal",
      "getConcessionOfficeTotal",
      "getPaymentSummary",
      "getFilmSummary",
      "getUserWiseSummary",
      "getRefundSummary",
      "getConcessionDailyReportData",
      "grandTotalForConcessionsReport",
      "getConcessionDailyExcelFileName",
      "getConcessionDailyPdfFileName",
    ]),
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    queryString() {
      let queryString = ``;
      let obj = {
        cinema_id: this.selectedCinema.cine_id,
        start_date: this.selectedDate
          ? moment(this.selectedDate).format("DD-MM-YYYY")
          : null,
        screen_id: this.selectedScreen.screen_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      queryString = this.createQueryString(obj);
      return queryString;
    },
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.cineDropDownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj,
          index: null,
        });
      }
    },
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.cinema_id = cinemaId;
    this.getCinemaList(cinemaId);
    //this.getOccupancyStatus({cinemaId})
  },
  destroyed: function () {
    clearInterval(this.interval);
    clearInterval(this.timer);
  },
  mounted() {
    this.time();
    this.interval = setInterval(() => {
      this.$forceUpdate();
    }, 1000);
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema.cine_name = CinemaObj.cine_name;
      this.cineDropDownHandler({
        event: null,
        name: "Cinema",
        selectedItem: CinemaObj,
        index: null,
      });
    }
    this.getCinemaOverviewReport();
  },
  methods: {
    createQueryString,
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      "fetchPosUsersList",
      "fetchPaymentTypesList",

      // FETCH LIST ONLY
      "fetchDailyReportListv2",
      "onDailyReportDateHandler",
      "onDailyReportDropdownHandler",
      "onDailyReportFlagHandler",
      "onFetchDailyConcessionReport",
      // ON RESET ALL
      "onResetDailyReportStoreState",
    ]),
    toggleRow(status, index) {
      console.log("toggleRow item");
      this.myCinemaSchedule[index]["moreDetailsCollapse"] =
        !this.myCinemaSchedule[index]["moreDetailsCollapse"];
      this.$forceUpdate();
      console.log(
        'this.myCinemaSchedule[index]["moreDetailsCollapse"]',
        this.myCinemaSchedule[index]["moreDetailsCollapse"]
      );
    },
    combineDateAndTime(date, time) {
      let timeString = moment(time, "HH:mm:ss").format("HH:mm");
      var dateString = moment(date).format("YYYY-MM-DD");
      var combined = new Date(dateString + " " + timeString);
      return combined;
    },
    time() {
      var self = this;
      this.timer = setInterval(self.time, 60 * 60 * 1000);
    },
    timeRemainingCounter(Time, tz_name) {
      var startDate = new Date(Time);
      var endDate = new Date();
      if (tz_name) {
        endDate = new Date(momentT().tz(tz_name).format("YYYY-MM-DD HH:mm"));
      }
      var endDate = new Date(momentT().tz(tz_name).format("YYYY-MM-DD HH:mm"));
      if (moment(endDate).isAfter(moment(startDate))) {
        return "-";
      }
      var diff = startDate.getTime() - endDate.getTime();
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (hours < 0) hours = hours + 24;
      let text = ``;
      if (days) {
        text =
          (days <= 9 ? "0" : "") +
          days +
          "d" +
          ":" +
          (hours <= 9 ? "0" : "") +
          hours +
          "h" +
          ":" +
          (minutes <= 9 ? "0" : "") +
          minutes +
          "m";
      } else {
        text =
          (hours <= 9 ? "0" : "") +
          hours +
          "h" +
          ":" +
          (minutes <= 9 ? "0" : "") +
          minutes +
          "m";
      }

      return text;
    },
    udpateDcpInfo(item) {
      let loader = vue.$loading.show();

      item["lead_time_in_hours"] = `${item.lead_hr}:${item.lead_mn}`;

      ReportService.UpdateCinemaOverView(item)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
            this.getCinemaOverviewReport();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
      } else {
        this.currentPage = event;
      }
      this.getCinemaOverviewReport();
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = this.rows;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCinemaOverviewReport();
    },
    formatTimeCell(time) {
      return moment(time, "HH:mm:ss").format("HH:mm");
    },
    onSelectCinema(cinema) {
      this.currentPage = 1;
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    missingData(item) {
      if (
        !item.kdm_id ||
        !item.key_valid_from ||
        !item.key_valid_to ||
        !item.tms_id ||
        !item.lead_hr ||
        !item.lead_mn
      ) {
        return true;
      } else {
        return false;
      }
    },
    onSelectKdm(kdm, index) {
      this.myCinemaSchedule[index].selected_kdm = kdm;
      this.myCinemaSchedule[index].kdm = kdm.kdm_title;
      this.myCinemaSchedule[index].kdm_id = kdm.kdm_id;
    },

    parseTime(time) {
      return moment(time).format("HH:mm");
    },

    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },

    onFetchReport() {
      this.getCinemaOverviewReport();
    },

    getCinemaList: function (cine_id) {
      this.Cinemas = [];

      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getCinemaOverviewReport() {
      if (!this.selectedCinema.cine_id && false) {
        vue.toasted.show("Please select a cinema");
        return;
      } else {
        let loader = vue.$loading.show();
        this.myCinemaSchedule = [];
        let payload = {
          cinema_id: this.selectedCinema.cine_id,
          start_date: this.selectedDate
            ? moment(this.selectedDate).format("DD-MM-YYYY")
            : null,
          screen_id: this.selectedScreen.screen_id,
          limit: this.perPage,
          currentPage: this.currentPage,
          columnName: this.columnName,
          orderBy: this.orderby,
        };

        ReportService.GetCinemaOverview(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              data.Records.forEach((x) => {
                if (x.lead_time_in_hours) {
                  let split = x.lead_time_in_hours.split(":");
                  if (split.length) {
                    x["lead_hr"] = split[0];
                    x["lead_mn"] = split[1];
                  } else {
                    x["lead_hr"] = "00";
                    x["lead_mn"] = "00";
                  }
                } else {
                  x["lead_hr"] = "00";
                  x["lead_mn"] = "00";
                }

                if (x.kdm_id && x.kdm) {
                  x["selected_kdm"] = {
                    kdm_id: x.kdm_id,
                    kdm_title: x.kdm,
                  };
                }

                x["moreDetailsCollapse"] = false;
              });
              if (data.totalRows) {
                this.rows = data.totalRows;
                if (data.totalRows < 10) {
                  this.selectedvalue = data.totalRows;
                } else {
                  this.selectedvalue = this.perPage;
                }
              }
              this.myCinemaSchedule = data.Records;
            } else {
              this.myCinemaSchedule = [];
              console.log("Error:", data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.$toasted.show(err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    async cineDropDownHandler({ event, name, selectedItem, index }) {
      this.selectedScreen = { screen_id: null };
      this.selectedCinema = selectedItem;

      let loader = vue.$loading.show();
      let { data: ScreenData } = await CinemasService.GetActiveScreenByCinema({
        tableName: "screens",
        activekey: "screen_is_active",
        conditionColName: "cinema_id",
        conditionId: this.selectedCinema.cine_id,
        limit: 100,
        currentPage: 1,
        searchValue: "",
        searchKey: "screen_name",
        columnName: "",
        orderBy: "screen_id",
      }).catch((e) => {
        vue.toasted.show(e.message || "Please try later");
      });
      loader.hide();
      if (ScreenData && ScreenData.status) {
        ScreenData.Records = ScreenData.Records.filter(
          (x) => x.screen_layout_active && x.screen_is_active
        ).sort((a, b) => a.screen_id - b.screen_id);

        this.CineScreens = ScreenData.Records || [];
      } else {
        vue.toasted.show(data.message || "Please try later");
      }
    },
    onClearDate() {
      this.selectedDate = null;
      this.getCinemaOverviewReport();
    },
    onDateHandler(d) {
      if (!(d instanceof Date && !isNaN(d))) d = new Date();
      this.currentPage = 1;
      this.selectedDate = new Date(d);
      this.getCinemaOverviewReport();
    },
    cineScreenDropDownHandler({ event, name, selectedItem, index }) {
      this.selectedScreen = selectedItem;
      this.currentPage = 1;
      this.getCinemaOverviewReport();
    },
  },
  beforeDestroy: async function () {},
};
</script>

<style>
.border-bottom-black {
  border-bottom: 1px solid #787878 !important;
}

.mobile-occupancy-report table {
  width: 100%;
}

.mobile-occupancy-report * {
  border-color: #eaeaed;
}

.mobile-occupancy-report .mobile-occupancy-sub-report {
  margin: 0 -15px 20px;
}

.mobile-occupancy-report .mobile-occupancy-sub-report td {
  padding: 10px;
}

.mobile-occupancy-report .mobile-occupancy-sub-report tr > td:first-child {
  font-weight: bold;
  background-color: #f5f5f7;
}

.mobile-occupancy-report .mobile-occupancy-sub-report .sub-report-toggle {
  padding: 10px 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-occupancy-report
  .mobile-occupancy-sub-report
  .sub-report-toggle
  span:not(:last-child)::after {
  content: "|";
  padding: 0 4px;
}

.movieNameCell {
  font-weight: bold;
  width: 120%;
  text-align: left;
  margin-right: 20px;
}

.cinema-overview-collapse {
  background-color: hsl(240, 56%, 94%);
  padding: 14px 16px;
  border-radius: 10px;
  margin: 13px;
}

.cinema-overview-collapse .input-material input {
  background: white;
}

.danger-border {
  border: 1px solid red !important;
  border-radius: 10px;
}

.missingData {
  color: red;
}

.collaplsePlusMinusBtn {
  font-size: 34px;
  line-height: 0px;
  font-weight: 500;
  color: #3876d2;
}

.collaplsePlusMinusBtn::after {
  transition: 0.3s ease;
  transform: translateY(-50%) rotate(180deg);
}

.tableHeaders {
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  font-weight: bold;
  height: 45px;
  /* padding: 0 30px; */
  border-bottom: 1px solid #d3d3d3;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.headFont {
  font-weight: bold;
}

.headerRow {
  background: #3876d2;
  color: white;
  padding-top: 0 !important;
  border-radius: 10px 10px 0px 0px;
}
.headerRowTable {
  background: #3876d2;
  color: white;
  height: 40px;
}

/* .headerRowTable th {
  border: none;
} */

.br-10 {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/cinemaOverviewReport.vue